import React from 'react';
import Base from './Base';

export default (props) => (
  <Base {...props}>
    <path d="M2.39,6h8.8c1,0,1.47.82,1.8,1.79l2.61,7a3.67,3.67,0,0,1,1.3-.33H46.75c1.47,0,3.1,1.31,2.61,2.77L46.1,27.36H21.47v2.29H41.53c2.28,0,3.1,1.14,3.1,2.44a3,3,0,0,1-2.77,2.78H18.37c-1.47,0-2.45-1.31-2.77-2.78L9.07,10.89H2.39C-.06,10.89-.06,6,2.39,6ZM39.08,37a3.48,3.48,0,0,1,3.59,3.42,3.59,3.59,0,1,1-7.17,0A3.47,3.47,0,0,1,39.08,37ZM20.82,37a3.48,3.48,0,0,1,3.59,3.42,3.59,3.59,0,0,1-7.18,0A3.48,3.48,0,0,1,20.82,37Z" />
  </Base>
);
